// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "div[data-v-10da9153]{right:0;bottom:0;padding:10px;position:fixed;color:#c0c4cc;font-size:12px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
